import { ApexOptions } from "apexcharts";
import axiosInstance from "../../utils/axiosConfig";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { API_URL } from "../../constant";
import { useAuth } from "../../context/auth-context";

const GrowthGraph = () => {
  const { isAuthenticated } = useAuth();

  const [total, setTotal] = useState<any[]>([]);
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // Get the current month (0-indexed)
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    axiosInstance
      .get(`${API_URL}api/stats/graph-data/GROWTH/YEAR?userType=basic-user`)
      .then((r: any) => {
        setTotal(r.data.data);
      })
      .catch((e: any) => {
        console.log(e.response.data.message);
      });
  }, [isAuthenticated]);

  const returnMonthDataActivated = (arr: any[]) => {
    const emptyArr = Array(12).fill(0);

    for (let i = 1; i <= emptyArr.length; i++) {
      const monthItem = arr.find(
        (item: { _id: { month: number } }) => item._id.month === i
      );
      emptyArr[i - 1] = monthItem ? monthItem.totalActivated : 0;
    }

    return emptyArr;
  };
  const returnMonthDataActive = (arr: any[]) => {
    const emptyArr = Array(12).fill(0);

    for (let i = 1; i <= emptyArr.length; i++) {
      const monthItem = arr.find(
        (item: { _id: { month: number } }) => item._id.month === i
      );
      emptyArr[i - 1] = monthItem ? monthItem.totalActive : 0;
    }

    return emptyArr;
  };
  const returnMonthDataUpgraded = (arr: any[]) => {
    const emptyArr = Array(12).fill(0);

    for (let i = 1; i <= emptyArr.length; i++) {
      const monthItem = arr.find(
        (item: { _id: { month: number } }) => item._id.month === i
      );
      emptyArr[i - 1] = monthItem ? monthItem.totalUpgraded : 0;
    }

    return emptyArr;
  };

  const xAxisCategories = months.slice(0, currentMonth + 1);
  const chartData = {
    series: [
      {
        name: "Activated",
        data: returnMonthDataActivated(total).slice(0, currentMonth + 1),
        color: "#FFFFFF",
        fill: {
          type: "solid",
          colors: "#262E35",
        },
      },
      {
        name: "Active",
        data: returnMonthDataActive(total).slice(0, currentMonth + 1),
        color: "#095B97",
        fill: {
          type: "solid",
          colors: "#262E35",
        },
      },
      {
        name: "Upgraded",
        data: returnMonthDataUpgraded(total).slice(0, currentMonth + 1),
        color: "#F28A0F",
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "category",
        categories: xAxisCategories,
        tickAmount: 12, // Show all 12 months on the x-axis
        labels: {
          style: {
            fontSize: "12px", // Adjust font size
            fontFamily: "Manrope, sans-serif", // Change font family
            fontWeight: "normal", // Set font weight
            colors: "#999999", // Set font color
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            fontSize: "12px", // Adjust font size
            fontFamily: "Manrope, sans-serif", // Change font family
            fontWeight: "normal", // Set font weight
            colors: "#999999", // Set font color
          },
          formatter: (value: any) =>
            // `${
            //   payoutCurrency === "USD"
            //     ? `$${value}k`
            //     : payoutCurrency === "NGN"
            //     ? `N${value}k`
            //     : null
            // }}`
            `${`${value.toLocaleString("en-US")}`}`, // Format y-axis labels as dollars
        },
        min: 0, // Set the minimum value of the y-axis
        max: 100, // Set the maximum value of the y-axis
        tickAmount: 5, // Number of ticks on the y-axis
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },

        style: {
          fontSize: "12px", // Adjust font size
          fontFamily: "Manrope, sans-serif", // Change font family
          fontWeight: "normal", // Set font weight
          colors: "#FFFFFF", // Set font color
        },
        theme: "dark", // Use the dark theme for the tooltip
      },
      grid: {
        show: false, // Remove the horizontal and vertical grid lines
      },
    },
  };
  return (
    <div className="w-full">
      <ReactApexChart
        options={chartData.options as ApexOptions}
        series={chartData.series}
        type="area"
        height={300}
      />
    </div>
  );
};

export default GrowthGraph;
